import Vue from 'vue'

// 只描述当前路由的等待过程，不缓存权限、Token或大屏配置。
export function createPageLoadFeedback (clock = { setTimeout: (fn, delay) => setTimeout(fn, delay), clearTimeout: id => clearTimeout(id) }) {
  const state = Vue.observable({ status: 'loading', title: '正在启动可视化', detail: '正在准备页面资源…', slow: false, target: '' })
  let generation = 0, timer
  const stop = () => { if (timer !== undefined) clock.clearTimeout(timer); timer = undefined }
  const current = ticket => ticket === generation && state.status === 'loading'
  return {
    state,
    current,
    begin (target) {
      stop()
      const ticket = ++generation
      Object.assign(state, { status: 'loading', title: '正在打开页面', detail: '正在准备页面资源…', slow: false, target })
      timer = clock.setTimeout(() => { if (current(ticket)) state.slow = true }, 6000)
      return ticket
    },
    stage (ticket, detail) { if (current(ticket)) state.detail = detail },
    finish (target) {
      if (state.status !== 'loading' || target !== state.target) return
      stop()
      state.status = 'idle'
      state.slow = false
    },
    fail (ticket, message) {
      if (!current(ticket)) return
      stop()
      Object.assign(state, { status: 'error', title: '页面暂时无法打开', detail: message || '网络连接异常，请检查连接后重试', slow: false })
    },
    failResource () {
      this.fail(generation, '页面资源加载失败，请检查网络后重试；更新部署后仍失败可刷新页面')
    },
    dismiss () {
      if (state.status !== 'error') return
      stop()
      generation++
      state.status = 'idle'
    }
  }
}

export const pageLoadFeedback = createPageLoadFeedback()
